import dkAxios from '@/jslib/dk-axios'

export const getExchangeData = data => dkAxios({
  url: '/v1/cms/Exchange',
  method: 'GET',
  params: data,
});

export const setExchangeStatus = data => dkAxios({
  url: '/v1/cms/Exchange/setExchangeStatus',
  method: 'POST',
  params: data,
});

export const getExchangeDetail = data => dkAxios({
  url: '/v1/cms/Exchange/getExchangeDetail',
  method: 'POST',
  params: data,
});

export const getExchangeRules = data => dkAxios({
  url: '/v1/cms/Config/exchange_rule',
  method: 'GET',
  params: data,
});

export const setExchangeRules = data => dkAxios({
  url: '/v1/cms/Config/exchange_rule',
  method: 'PUT',
  data,
});



// WEBPACK FOOTER //
// ./src/api/exchange.js